import React from "react";
import HomePage from "./pages/Home/Home";

const App = () => {
  return <HomePage />;
};

export default App;
